import { useEffect, useState } from 'react';

/**
 * Sigilo dos valores na tela.
 *
 * A KAIRÓS trabalha em reunião, em cliente, em café. Deixar honorário à mostra
 * numa tela que alguém pode olhar por cima do ombro é o tipo de vazamento que
 * não precisa de invasor nenhum.
 *
 * Com o sigilo ligado, todo valor vira `R$ ••••`. **É máscara de tela, não
 * criptografia**: o dado continua no banco e na resposta da API. Serve contra
 * olhar alheio, não contra quem tem acesso ao sistema.
 *
 * A escolha vive no navegador — é do aparelho, como o tema.
 */
const CHAVE = 'kairos-sigilo';
const ouvintes = new Set<(ligado: boolean) => void>();

let ligado = localStorage.getItem(CHAVE) === 'ligado';

export function sigiloLigado(): boolean {
  return ligado;
}

export function alternarSigilo(): void {
  ligado = !ligado;
  localStorage.setItem(CHAVE, ligado ? 'ligado' : 'desligado');
  ouvintes.forEach((o) => o(ligado));
}

export function usarSigilo(): boolean {
  const [atual, setAtual] = useState(ligado);
  useEffect(() => {
    const aoMudar = (novo: boolean) => setAtual(novo);
    ouvintes.add(aoMudar);
    return () => {
      ouvintes.delete(aoMudar);
    };
  }, []);
  return atual;
}
